import { makeAutoObservable } from "mobx";
import * as api from "~/api";
import { Document, DocumentProto } from "~/document";

class BulkDownloadStore {
  selectedDocuments: Map<DocumentProto, Document> = new Map();
  status: api.ReqStatus = api.ReqStatus.Initial;

  constructor() {
    makeAutoObservable(this);
  }

  get selectedSomething() {
    return this.selectedDocuments.size !== 0;
  }

  get selectedDocumentsList(): Document[] {
    return [...this.selectedDocuments.values()];
  }

  setBulkDownloadSelected(doc: Document, value: boolean) {
    if (value) {
      this.selectedDocuments.set(doc.protocol, doc);
    } else {
      this.selectedDocuments.delete(doc.protocol);
    }
  }

  isBulkDownloadSelected(itemProto: DocumentProto) {
    return this.selectedDocuments.has(itemProto);
  }

  download = async (): Promise<boolean> => {
    const documents = this.selectedDocumentsList.map((doc) => doc.dbid ?? doc.id);
    this.status = api.ReqStatus.InProcess;
    try {
      const resp = await api.post(`documents/download_zip`, { documents }, { responseType: "blob" });
      if (resp === null) return false;
      const url = window.URL.createObjectURL(
        new Blob([resp!.data], { type: resp.headers["content-type"] as string }),
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "documents.zip");
      document.body.appendChild(link);
      link.click();
      this.status = api.ReqStatus.Success;
      // Free the memory
      URL.revokeObjectURL(url);
      return true;
    } catch (error: any) {
      this.status = api.ReqStatus.Failed;
      if (!error.response) throw error;
      return false;
    }
  };

  clearSelection = () => {
    this.selectedDocuments = new Map();
  };
}

const bulkDownloadStore = new BulkDownloadStore();

export default bulkDownloadStore;
